import React from "react"
import ReactDOM from "react-dom/client"
import { PWA_UPDATE_AVAILABLE } from "constants/events"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { register } from "./serviceWorkerRegistration"
import "./index.css"

const rootElement = document.getElementById("root") as HTMLElement
const splashScreen = document.getElementById("splash-screen") as HTMLElement

const root = ReactDOM.createRoot(rootElement)

root.render(
  // <React.StrictMode>
    <App/>
  // </React.StrictMode>
)

setTimeout(() => {
  splashScreen?.remove()
}, 10)

register({
  onUpdate: () => {
    setTimeout(() => document.dispatchEvent(new CustomEvent(PWA_UPDATE_AVAILABLE)), 2000)
  }
})

reportWebVitals()
